import { useCallback } from 'react'
import type { ProductSegments, Segments } from 'types/segmentation'
import { useUserData } from 'user-data/hooks/useUserData'

/* eslint react-hooks/exhaustive-deps: warn */

const NO_SEGMENT = ''

export function useSegmentation(): {
	getProductSegment: (catalogId: string) => string
	segmentation: Segments | undefined
} {
	const { segmentation } = useUserData()

	const getProductSegment = useCallback(
		(catalogId?: string): string => {
			if (!catalogId) {
				return NO_SEGMENT
			}
			const productSegment: ProductSegments = segmentation?.product ?? {}
			return productSegment[catalogId] ?? NO_SEGMENT
		},
		[segmentation?.product]
	)

	return { segmentation, getProductSegment }
}
